import queryString from 'query-string';

// function stringify(queryObject: Record<string, any>): string {
//   const keys = Object.keys(queryObject);
//   return keys
//     .map((key) => {
//       const value = queryObject[key];
//       if (value === null) {
//         return '';
//       }
//       if (value === '') {
//         return '';
//       }
//       return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
//     })
//     .filter((part) => part !== '')
//     .join('&');
// }

// export default function updateQueryStringParameter(
//   search: string,
//   newParams: any,
// ) {
//   return stringify({ ...parseParams(search), ...newParams });
// }

export default function updateQueryStringParameter(
  search: string,
  newParams: any,
) {
  const searchObj = queryString.parse(search);

  return queryString.stringify(
    { ...searchObj, ...newParams },
    {
      skipNull: true,
      skipEmptyString: true,
      sort: (a, b) => {
        if (a === 'page') return -1;
        if (b === 'page') return 1;
        if (a === 'page_size') return -1;
        if (b === 'page_size') return 1;

        return 0;
      },
    },
  );
}
